import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthWebService } from 'app/services/authweb.service';

@Component({
  selector: 'app-run-extracts',
  templateUrl: './run-extracts.component.html',
  styleUrls: ['./run-extracts.component.scss']
})
export class RunExtractsComponent implements OnInit {
  
  public iframeUrl: any = null;
  public user: any = null;

  constructor(public sanitizer: DomSanitizer, private authWebService: AuthWebService) {
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
  }

  ngOnInit() {
    console.log(JSON.stringify(this.user));
    console.log('VTE URl', environment.extractToView.url + "dataexport/ifrmExportListing.aspx?UserID=" + this.user.Id);
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.extractToView.url + "dataexport/ifrmExportListing.aspx?UserID=" + this.user.Id);
  }
  back(){
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.extractToView.url + "dataexport/ifrmExportListing.aspx?UserID=" + this.user.Id + " ");
    console.log('VTE URl', environment.extractToView.url + "dataexport/ifrmExportListing.aspx?UserID=" + this.user.Id);
  }
}
